<template>
  <div class="comboard-container">
    <div class="comboard-container-outer">
      <div class="comboard-content">
        <div
          v-show="!comboardLoad && (comboardMerged.length != 0)"
          v-for="(data, index) in comboardMerged"
          :key="index"
          class="comboard-card-content"
        >
          <!-- Header -->
          <div class="comboard-card-header">
            <div class="card-header-icon">
              <icon :path="mdiNewspaperVariantOutline" />
            </div>

            <div class="card-header-info">
              <p v-html="data.title" />
              <p v-html="data.created_by" />
              <p v-html="(data.datetime_1 && data.datetime_2) ? dateFormat(data.datetime_1, data.datetime_2) : dateFormat(data.show_date)"></p>
            </div>

            <div class="card-header-action">

            </div>
          </div>

          <div class="comboard-content-outer">
            <!-- Video -->
            <div v-if="data.link_url && data.file_img && (data.file_img.length == 0)" class="comboard-card-video">
              <iframe
                :src="buildYoutubeUrl(data.link_url)"
                frameborder="0"
                allowfullscreen>
              </iframe>
            </div>

            <!-- Carousel -->
            <div v-if="data.file_img && (data.file_img.length != 0)" class="comboard-card-carousel">
              <Carousel :mouse-drag="false" :touch-drag="false" :wrap-around="(data.file_img.length > 1) || ((data.file_img.length == 1) && data.link_url)" :autoplay="(data.file_img.length > 1) || ((data.file_img.length == 1) && data.link_url) ? 4000 : 0">
                <Slide v-if="data.link_url">
                  <iframe
                    :src="buildYoutubeUrl(data.link_url)"
                    frameborder="0"
                    allowfullscreen>
                  </iframe>
                </Slide>

                <Slide v-for="content in data.file_img" :key="content">
                  <img :src="content">
                </Slide>

                <template #addons v-if="(data.file_img.length > 1) || ((data.file_img.length == 1) && data.link_url)">
                  <Navigation/>
                  <Pagination/>
                </template>
              </Carousel>
            </div>

            <!-- Content -->
            <div class="comboard-card-info">
              <div
                :ref="el => setContentRef(el, index)"
                :class="{ 'clamp-2': !expanded[index] }"
                v-html="data.info"
              ></div>

              <div v-if="showButton[index]" class="mt-1 text-center">
                <span
                  @click="toggle(index)"
                  style="color: #1976d2; cursor: pointer; font-weight: 500; font-size: 14px; line-height: 20px;"
                >
                  {{ expanded[index] ? 'Show Less' : 'Show More' }}
                </span>
              </div>
            </div>

            <!-- File -->
            <div v-if="showFiles[data.id]" class="comboard-card-file">
              <div class="file-outer">
                <div class="file-container">
                  <div class="file-content" v-for="file_data in data.file_1" :key="file_data" @click="download(file_data.file, '/download-comboard', data.id)" :title="file_data.file">
                    <icon :path="mdiFileDownloadOutline" />
                    <p>{{ file_data.file }}</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Action -->
            <div class="comboard-card-action">
              <div
                class="card-action-button"
                @click="toggleFiles(data)"
                :style="{
                  cursor: data.file_1.length ? 'pointer' : 'default',
                  opacity: data.file_1.length ? 1 : 0.5
                }"
              >
                <icon :path="mdiFile" />
                <p>{{ data.file_1.length }} {{ data.file_1.length > 1 ? 'Files' : 'File' }}</p>
              </div>

              <div
                @click="toggleComments(data)"
                class="card-action-button"
                :style="{
                  cursor: data.comments.length ? 'pointer' : 'default',
                  opacity: data.comments.length ? 1 : 0.5
                }"
              >
                <icon :path="mdiCommentTextMultipleOutline" />
                <p>{{ data.total_comments }} {{ data.total_comments > 1 ? 'Comments' : 'Comment' }}</p>
              </div>
            </div>

            <!-- Comment -->
            <div
              v-if="commentState[data.id]?.open"
              class="comboard-card-comment"
            >
              <div class="comboard-card-comment-outer">
                <SectionComboardComment
                  :dataComment="commentState[data.id]?.comment.comments"
                  :comboardId="data.id"
                  @delete-comment="deleteComment"
                  @reply-comment="replyComment"
                />
              </div>

              <div class="comboard-comment-send">
                <form @submit.prevent="store(data.id)">
                  <!-- <textarea name="" id="" /> -->
                  <textarea
                    v-model="commentInput[data.id]"
                    :placeholder="'Type Your Comment On Here'"
                    type="text"
                  />
                  <button type="submit">
                    <icon :path="mdiSend" />
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div v-show="!comboardLoad && (comboardMerged.length == 0)">

        </div>

        <div v-show="comboardLoad" class="comboard-card-loading">
          <div class="card-loading-header" />
          <div class="card-loading-image" />
          <div class="card-loading-text" />
          <div class="card-loading-text" />
          <div class="card-loading-action" />
        </div>
      </div>
    </div>
  </div>

  <vue-final-modal
    v-model="deleteModal"
    classes="base-modal"
    :ssr="true"
    :content-class="darkMode ? 'delete-modal bg-darkmode-base transition-colors duration-1000' : 'delete-modal bg-gray-100 transition-colors duration-1000'"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1>{{ $t('menu.delete') }} {{ $t('menu.data') }}</h1>

      <jb-button class="btn-close-modal" :icon="mdiClose" @click="deleteModal = false" />
    </div>

    <!-- Modal content -->
    <div class="delete-content">
      <div class="warning">{{ $t('menu.warning') }}</div>

      <div class="messsage"><p>{{ $t('confirmDelete.message') }}</p></div>
    </div>

    <!-- Button action -->
    <div class="buttons-submit transition-colors duration-1000" :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'">
      <jb-buttons class="buttons-action-submit">
        <jb-button :label="$t('finance.button.btnConfirm')" color="info" :icon="mdiTrashCan" @click="confirm" class="form-submit-btn" />
        <jb-button :label="$t('finance.button.btnCancel')" outline @click="cancel" class="btn-reset form-noicon-btn" />
      </jb-buttons>
    </div>
  </vue-final-modal>
</template>

<script>
  /* eslint-disable */
  import { ref, reactive, onMounted, onUnmounted, watch, watchEffect, computed, nextTick } from 'vue'
  import { useToast } from 'vue-toastification'
  import { useI18n } from 'vue-i18n'
  import { AgGridVue } from 'ag-grid-vue3'
  import axios from 'axios'
  import Datepicker from "@vuepic/vue-datepicker"
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import dayjs from 'dayjs'
  import 'dayjs/locale/id'
  import { Carousel, Pagination, Slide, Navigation } from 'vue3-carousel'
  import 'vue3-carousel/dist/carousel.css'
  import JbButton from '@/components/JbButton'

  import { mdiNewspaperVariantOutline, mdiCommentTextMultipleOutline, mdiFileDownloadOutline, mdiFile, mdiClose, mdiSend, mdiTrashCan } from '@mdi/js'

  import Icon from "@/components/Icon"
  import SectionComboardComment from './SectionComboardComment.vue'

  export default {
    components: {
      Icon,
      Carousel,
      Pagination,
      Slide,
      Navigation,
      SectionComboardComment,
      JbButton
    },

    props: {
      comboardLoad: { type: Boolean, default: false },
      comboardMerged: { type: Array, default: () => [] },
      containerWidth: { type: Number, default: 0 },
      containerHeight: { type: Number, default: 0 },
      isMobile: { type: Boolean, default: false },
      isSmall: { type: Boolean, default: false },
      isMedium: { type: Boolean, default: false },
      isLarge: { type: Boolean, default: false },
      isXl: { type: Boolean, default: false },
    },

    setup (props, { emit }) {
      const toast = useToast()
      const isLoading = ref(false)
      const userLogin = localStorage.getItem('name')



      dayjs.locale('id')
      const dateFormat = (date1, date2 = null) => {
        const d1 = dayjs(date1)
        const d2 = date2 ? dayjs(date2) : null

        if (!d1.isValid()) return ''

        if (!d2 || !d2.isValid()) {
          return d1.format('D MMMM YYYY')
        }

        if (d1.isSame(d2, 'day')) {
          return d1.format('D MMMM YYYY')
        }

        const sameMonth = d1.isSame(d2, 'month')
        const sameYear = d1.isSame(d2, 'year')

        if (sameMonth && sameYear) {
          return `${d1.format('D')}-${d2.format('D MMMM YYYY')}`
        }

        if (!sameMonth && sameYear) {
          return `${d1.format('D MMM')} - ${d2.format('D MMM YYYY')}`
        }

        return `${d1.format('D MMM YYYY')} - ${d2.format('D MMM YYYY')}`
      }


      const buildYoutubeUrl = (url) => {
        if (!url) return ''

        try {
          const parsed = new URL(url)

          let videoId = ''

          if (parsed.searchParams.get('v')) {
            videoId = parsed.searchParams.get('v')
          }

          else if (parsed.hostname.includes('youtu.be')) {
            videoId = parsed.pathname.replace('/', '')
          }

          else if (parsed.pathname.includes('/embed/')) {
            videoId = parsed.pathname.split('/embed/')[1]
          }

          if (!videoId) return ''

          const embedUrl = new URL(`https://www.youtube.com/embed/${videoId}`)

          embedUrl.searchParams.set('rel', '0')
          embedUrl.searchParams.set('modestbranding', '1')
          embedUrl.searchParams.set('playsinline', '1')

          return embedUrl.toString()
        } catch (e) {
          return ''
        }
      }


      const expanded = reactive({})
      const showButton = reactive({})
      const contentRefs = ref([])

      const setContentRef = (el, index) => {
        if (el) {
          contentRefs.value[index] = el
        }
      }

      const checkOverflow = async () => {
        await nextTick()

        contentRefs.value.forEach((el, index) => {
          if (!el) return

          el.classList.add('clamp-2')

          const isOverflowing = el.scrollHeight > el.clientHeight + 1
          showButton[index] = isOverflowing
        })
      }

      const toggle = (index) => {
        expanded[index] = !expanded[index]
      }

      watch(() => props.comboardMerged, () => {
        nextTick(() => {
          checkOverflow()
          // console.log("cek data comboard", props.comboardMerged)
        })
      }, { immediate: true })



      const showFiles = reactive({})
      const toggleFiles = (board) => {
        if (!board.file_1 || board.file_1.length === 0) return

        showFiles[board.id] = !showFiles[board.id]
      }

      const download = (name, url, id) => {
        const data = {
          filename: name,
          id: id
        }
        axios
        .get(url, {
          params: data,
          responseType: 'blob'
        })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute('download', name)
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .catch((error) => {
          console.log(error)
          downloadDoc(name, url, id)
        })
      }
      const downloadDoc = (name, url, id) => {
        const data = {
          filename: name,
          id: id
        }
        axiosDocument
        .get('download-comboard', {
          params: data,
          responseType: 'blob'
        })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute('download', name)
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .catch((error) => {
          console.log('ERROR', error)
        })
      }


      const commentState = ref({})
      const toggleComments = (data) => {
        const id = data.id

        if (!commentState.value[id]) {
          commentState.value[id] = {
            open: true,
            comment: {
              ...data,
              comments: data.comments ? [...data.comments] : []
            }
          }
        } else {
          commentState.value[id].open = !commentState.value[id].open
        }

        // console.log("cek commnet", commentState)
      }

      watchEffect(() => {
        // console.log("cek ges", props.comboardMerged)
      })


      // ===== Comment =====
      const commentInput = reactive({})
      const deleteModal = ref(false)
      const deleteComboards = ref(null)
      const deleteType = ref('comment')
      const isDeleting = ref(false)

      const store = async (boardId) => {
        const commentText = commentInput[boardId]?.trim()

        if (!commentText) {
          toast.warning('Komentar tidak boleh kosong')
          return
        }

        const tempComment = {
          id: `temp-${Date.now()}`,
          name: userLogin,
          comment: commentText,
          created_at: dayjs().format('DD MMM YYYY HH:mm'),
          created_by: localStorage.getItem('username'),
        }

        if (!commentState.value[boardId]) {
          commentState.value[boardId] = { open: true, comment: { comments: [] } }
        }

        commentState.value[boardId].comment.comments = [
          tempComment,
          ...commentState.value[boardId].comment.comments
        ]

        commentInput[boardId] = ''

        const dataSubmit = {
          name: userLogin,
          comment: commentText,
          comboard_id: boardId,
          created_by: localStorage.getItem('username')
        }

        try {
          const response = await axios({
            method: props.showEdit ? 'PUT' : 'POST',
            url: props.showEdit
              ? `comboard-detail/${commentInput.id}`
              : 'comboard-detail',
            data: dataSubmit
          })

          if (response.data.success) {
            toast.success(response.data.message || 'Komentar berhasil dikirim')

            const realComment = response.data.data || response.data.comment

            if (realComment) {
              const idx = commentState.value[boardId].comment.comments.findIndex(
                c => c.id === tempComment.id
              )
              if (idx !== -1) {
                const updated = [...commentState.value[boardId].comment.comments]
                updated[idx] = { ...realComment, name: userLogin }
                commentState.value[boardId].comment.comments = updated
              }
            } else {
              const idx = commentState.value[boardId].comment.comments.findIndex(
                c => c.id === tempComment.id
              )
              if (idx !== -1) {
                commentState.value[boardId].comment.comments.splice(idx, 1)
              }
            }

            emit('refresh-comboard')
          } else {
            throw new Error(response.data.message)
          }
        } catch (error) {
          console.error(error)

          commentState.value[boardId].comment.comments = commentState.value[boardId].comment.comments.filter(
            c => c.id !== tempComment.id
          )

          toast.error('Gagal mengirim komentar. Silakan coba lagi.')
        }
      }

      const replyComment = async ({ parent, text }) => {
        const boardId = parent.comboard_id

        if (!text?.trim()) {
          toast.warning('Reply tidak boleh kosong')
          return
        }

        const findComment = (comments, targetId) => {
          for (const c of comments) {
            if (c.id === targetId) return c
            if (c.replies?.length) {
              const found = findComment(c.replies, targetId)
              if (found) return found
            }
          }
          return null
        }

        const boardComments = commentState.value[boardId]?.comment?.comments || []
        // const parentComment = boardComments.find(c => c.id === parent.id)
        const parentComment = findComment(boardComments, parent.id)

        if (!parentComment) {
          toast.error('Parent comment tidak ditemukan di state')
          return
        }

        const tempReply = {
          id: `temp-${Date.now()}`,
          parent_comment_id: parent.id,
          name: userLogin,
          comment: text,
          created_at: dayjs().format('DD MMM YYYY HH:mm'),
          comboard_id: boardId,
          replies: []
        }

        // Optimistic UI — replace array agar reaktif
        parentComment.replies = [tempReply, ...(parentComment.replies || [])]

        // Force Vue detect perubahan
        commentState.value[boardId].comment.comments = [
          ...commentState.value[boardId].comment.comments
        ]

        try {
          const response = await axios({
            method: 'POST',
            url: 'comboard-detail',
            data: {
              name: userLogin,
              comment: text,
              comboard_id: boardId,
              parent_comment_id: parent.id,
              created_by: localStorage.getItem('username'),
              detail_id: parent.id,
              head_id: parent.head_id || null,
              reply: true
            }
          })

          if (response.data.success) {
            toast.success('Reply terkirim')
            emit('refresh-comboard')
          } else {
            throw new Error(response.data.message || 'Gagal menyimpan reply')
          }
        } catch (e) {
          console.error('Error saat reply:', e)
          toast.error('Reply gagal dikirim. Silakan coba lagi.')

          // Rollback
          parentComment.replies = parentComment.replies.filter(r => r.id !== tempReply.id)
          commentState.value[boardId].comment.comments = [
            ...commentState.value[boardId].comment.comments
          ]
        }
      }

      const deleteComment = async (commentId) => {
        deleteComboards.value = commentId
        deleteType.value = 'comment'
        deleteModal.value = true
      }

      const showModal = () => {
        deleteModal.value = !deleteModal.value
      }

      const cancel = () => (deleteModal.value = false)

      const confirm = async () => {
        if (commentInput.detail_delete === 'header') {
          confirmDelete()
        } else if (deleteType.value === 'comment') {
          await confirmDeleteComment()
        }

        deleteModal.value = false
      }

      const confirmDeleteComment = async () => {
        const commentId = deleteComboards.value?.id

        if (!commentId) return
        isDeleting.value = true
        let found = false

        for (const boardId of Object.keys(commentState.value)) {
          const comments = commentState.value[boardId]?.comment?.comments || []
          const parentIndex = comments.findIndex(c => c.id === commentId)

          if (parentIndex !== -1) {
            commentState.value[boardId].comment.comments = comments.filter(
              c => c.id !== commentId
            )
            found = true
            break
          }

          for (const parent of comments) {
            if (!parent.replies) continue
            const childIndex = parent.replies.findIndex(c => c.id === commentId)

            if (childIndex !== -1) {
              parent.replies = parent.replies.filter(r => r.id !== commentId)
              found = true
              break
            }
          }

          if (found) break
        }

        if (!found) {
          toast.warning('Komentar tidak ditemukan di UI')
        }

        deleteModal.value = false

        try {
          const response = await axios({
            method: 'POST',
            url: 'deletecomment',
            params: { id: commentId }
          })

          if (response.data.success) {
            toast.success(response.data.message ?? 'Komentar berhasil dihapus')
          } else {
            throw new Error(response.data.message)
          }
        } catch (error) {
          console.error(error)
          toast.error('Gagal delete di server')
          emit('refresh-comboard')
        } finally {
          isDeleting.value = false
        }
      }

      // Tambah watch ini setelah deklarasi commentState
      watch(() => props.comboardMerged, (newVal) => {
        newVal.forEach(board => {
          // Hanya update board yang sedang terbuka
          if (commentState.value[board.id]?.open) {
            commentState.value[board.id].comment = {
              ...board,
              comments: board.comments ? [...board.comments] : []
            }
          }
        })
      }, { deep: true })

      return {
        toast,
        mdiSend,
        mdiTrashCan,
        mdiNewspaperVariantOutline,
        mdiCommentTextMultipleOutline,
        mdiFileDownloadOutline,
        mdiFile,
        dateFormat,
        buildYoutubeUrl,
        expanded,
        showButton,
        toggle,
        setContentRef,
        showFiles,
        toggleFiles,
        download,
        commentState,
        toggleComments,

        // ===== Comment =====
        commentInput,
        store,
        deleteComment,
        replyComment,
        deleteModal,
        confirm,
        cancel,
        showModal,
      }
    }
  }
</script>

<style lang="scss">
  .comboard-container {
    .comboard-container-outer {
      width: 100%;
      overflow-y: auto;
      position: relative;
      z-index: 2;

      .comboard-content {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        gap: 16px;
        // padding: 16px;
        padding-bottom: 40px;

        .comboard-card-content {
          width: 100%;
          height: auto;
          background-color: whitesmoke;
          box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;

          .comboard-card-header {
            width: 100%;
            display: flex;
            flex-direction: row;
            gap: 16px;
            background-color: white;

            .card-header-icon {
              width: 52px;
              height: auto;
              display: flex;
              justify-content: center;
              align-items: center;
              position: relative;
              border-right: 1px solid lightgray;

              svg {
                width: 24px;
                height: 24px;
              }
            }

            .card-header-info {
              width: calc(100% - 52px - 16px - 16px);
              padding: 4px 0;

              p {
                width: 100%;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;

                &:nth-child(1) {
                  font-size: 16px;
                  line-height: 24px;
                  font-weight: 600;
                  margin-bottom: 4px;
                }

                &:nth-child(2) {
                  font-size: 12px;
                  line-height: 18px;
                  font-weight: 500;
                }

                &:nth-child(3) {
                  font-size: 12px;
                  line-height: 18px;
                  font-weight: 600;
                }
              }
            }

            .card-header-action {
              width: 0;
            }
          }

          .comboard-content-outer {
            width: 100%;
            height: auto;
            padding: 16px 0 0 0;
            display: flex;
            flex-direction: column;
            gap: 16px;

            .comboard-card-video {
              width: 100%;
              padding: 0 16px;

              iframe {
                width: 100%;
                height: auto;
                aspect-ratio: 16 / 9;
              }
            }

            .comboard-card-carousel {
              padding: 0 16px;

              .carousel {
                width: 100%;
                height: auto;
                position: relative;
                overscroll-behavior: auto;

                .carousel__viewport {
                  .carousel__track {
                    .carousel__slide {
                      iframe, img {
                        width: 100%;
                        height: auto;
                        aspect-ratio: 16 / 9;
                        object-fit: cover;
                      }
                    }
                  }
                }


                .carousel__prev,
                .carousel__next {
                  width: 50px;
                  height: 50px;
                  background-color: rgba(0, 0, 0, 0.1);
                  backdrop-filter: blur(1px);
                  -webkit-backdrop-filter: blur(1px);
                  transition: background-color .5s, backdrop-filter .5s, -webkit-backdrop-filter .5s;
                  -webkit-tap-highlight-color: #3E70A5;

                  svg {
                    width: 50px;
                    height: 50px;

                    path {
                      fill: rgba(255, 255, 255, 0.5);
                      transition: fill .5s;
                    }
                  }


                  @media (min-width: 480px) {
                      &:hover {
                          background-color: rgba(0, 0, 0, 0.2);
                          backdrop-filter: blur(1.4px);
                          -webkit-backdrop-filter: blur(1.4px);

                          svg {
                              path {
                                  fill: white;
                              }
                          }
                      }
                  }
                }

                .carousel__prev {
                  left: -6px;
                }

                .carousel__next {
                  right: -6px;
                }

                .carousel__prev--disabled,
                .carousel__next--disabled {
                    opacity: 40%;
                    -webkit-tap-highlight-color: transparent;

                    &:hover {
                        background-color: rgba(0, 0, 0, 0.1);
                        backdrop-filter: blur(1px);
                        -webkit-backdrop-filter: blur(1px);
                    }
                }

                ol.carousel__pagination {
                  margin: 0 0 0 0;

                  li.carousel__pagination-item {
                    button {
                      &::after {
                        width: 10px;
                        height: 10px;
                        border-radius: 100%;
                        background-color: gray;
                      }
                    }

                    button.carousel__pagination-button--active {
                      &::after {
                        width: 16px;
                        border-radius: 16px;
                        background-color: blue;
                      }
                    }
                  }
                }
              }
            }

            .comboard-card-info {
              width: 100%;
              padding: 0 16px;

              .clamp-2 {
                width: 100%;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;

                p, b, span, strong, u, i, a {
                  font-size: 14px;
                  line-height: 24px;
                  font-weight: 500;
                }

                p, span, u, i {
                  color: rgb(42, 42, 42);
                }

                a {
                  color: rgb(8, 0, 255);
                }

                b, strong {
                  color: rgb(27, 27, 27);
                  font-weight: 600;
                }
              }
            }

            .comboard-card-file {
              width: 100%;
              padding: 16px 16px 0 16px;
              border-top: 1px solid lightgray;

              .file-outer {
                width: 100%;
                max-width: 100%;
                overflow-x: auto;

                .file-container {
                  width: max-content;
                  min-width: 100%;
                  display: flex;
                  flex-direction: row;
                  gap: 8px;

                  .file-content {
                    width: auto;
                    height: auto;
                    display: flex;
                    gap: 8px;
                    align-items: center;
                    background-color: #ff6811;
                    padding: 8px 12px;
                    cursor: pointer;

                    svg {
                      width: 24px;
                      height: 24px;

                      path {
                        fill: white;
                      }
                    }

                    p {
                      width: 100px;
                      text-overflow: ellipsis;
                      display: -webkit-box;
                      -webkit-line-clamp: 1;
                      -webkit-box-orient: vertical;
                      overflow: hidden;
                      font-size: 14px;
                      line-height: 20px;
                      font-weight: 500;
                      color: white;
                    }
                  }
                }
              }
            }

            .comboard-card-action {
              width: 100%;
              padding: 8px;
              display: flex;
              flex-direction: row;
              justify-content: end;
              gap: 8px;
              align-items: center;
              background-color: white;

              .card-action-button {
                width: auto;
                height: auto;
                display: flex;
                flex-wrap: nowrap;
                gap: 4px;
                align-items: center;
                cursor: pointer;
                transition: background-color .2s;
                padding: 8px;

                &:hover {
                  background-color: whitesmoke;
                }

                p {
                  font-size: 14px;
                  line-height: 20px;
                }
              }
            }

            .comboard-card-comment {
              width: 100%;
              padding: 0 16px 16px 16px;

              .comboard-card-comment-outer {
                width: 100%;
                height: 280px;
                max-height: 280px;
                overflow-y: auto;
                overscroll-behavior: contain;
              }

              .comboard-comment-send {
                width: 100%;
                height: auto;

                form {
                  width: 100%;
                  display: flex;
                  flex-wrap: nowrap;
                  align-items: center;
                  gap: 8px;

                  textarea {
                    width: calc(100% - 52px - 8px);
                    height: 56px !important;
                    min-height: 40px !important;
                    resize: none;
                    padding: 8px 16px;
                    font-size: 14px;
                    line-height: 20px;
                    margin: 0;
                    overflow-y: auto !important;
                  }

                  button {
                    width: 52px;
                    height: 52px;
                    background-color: #152751;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    svg {
                      path {
                        fill: white;
                      }
                    }
                  }
                }
              }
            }
          }
        }

        .comboard-card-loading {
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 16px;

          .skeleton {
            position: relative;
            overflow: hidden;
            background-color: #e3e3e3;

            &::after {
              content: "";
              position: absolute;
              inset: 0;
              transform: translateX(-100%);
              background: linear-gradient(
                90deg,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 0.5) 50%,
                rgba(255, 255, 255, 0) 100%
              );
              animation: shimmer 1.4s infinite;
            }
          }

          .card-loading-header {
            @extend .skeleton;
            width: 100%;
            height: 60px;
          }

          .card-loading-image {
            @extend .skeleton;
            width: 100%;
            aspect-ratio: 16 / 9;
          }

          .card-loading-text {
            @extend .skeleton;
            width: 100%;
            height: 24px;
          }

          .card-loading-action {
            @extend .skeleton;
            width: 20%;
            min-width: 100px;
            height: 20px;
            margin-left: auto;
          }
        }

        @keyframes shimmer {
          100% {
            transform: translateX(100%);
          }
        }
      }
    }
  }
</style>
